module.exports = __webpack_public_path__ + "img/globe.d3e44333.webp";